import s from './style.module.scss';

const UserMessage = ({ card = {} }) => {
    return (
        <div className={s['user-message-wrap']}>
            <div className={s['card-title']}>{card?.title}</div>
            <div className={s['card-description']}>{card?.describe}</div>
        </div>
    );
};
export default UserMessage;
